import { redirect } from '@sveltejs/kit'

const REDIRECT_TO = 'redirect-to'

/**
 * Redirects the user to the login page while preserving search params and the current
 * path – so the user can later be redirected to the previously requested page after
 * signing in.
 */
export function redirectToLogin(url: URL, auth?: boolean) {
  if (
    !url.searchParams.has(REDIRECT_TO) &&
    !(url.pathname === '' || url.pathname === '/')
  ) {
    const newSearchParams = new URLSearchParams([
      ...Array.from(url.searchParams.entries()),
    ])

    newSearchParams.set(REDIRECT_TO, url.pathname)

    redirect(307, `/${auth ? 'auth' : 'login'}?${newSearchParams}`)
  }

  if (!Array.from(url.searchParams).length) {
    redirect(307, auth ? '/auth' : '/login')
  }

  redirect(307, `/${auth ? 'auth' : 'login'}?${url.searchParams}`)
}

/**
 * Redirects the user to the previously requested page using the preserved search
 * params and path.
 */
export function redirectAfterSignIn(url: URL) {
  const redirectTo = url.searchParams.get(REDIRECT_TO)

  if (redirectTo) {
    const newSearchParams = new URLSearchParams([
      ...Array.from(url.searchParams.entries()),
    ])

    newSearchParams.delete(REDIRECT_TO)

    if (!Array.from(newSearchParams).length) {
      redirect(303, redirectTo)
    }

    redirect(303, `${redirectTo}?${newSearchParams}`)
  }
  redirect(303, '/')
}
